import React, { useState, useEffect, useRef } from "react";
import "./header.css";
import logo from "../../assets/images/logo/xixlogo.png";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import { FaArrowRight, FaFilm } from "react-icons/fa6";
import MobileHeader from "../mobile_header/MobileHeader";
import { useCookies } from "react-cookie";
import { IoCall } from "react-icons/io5";
import { getNavItems } from "../../utils/navConfig";
import { useTheme } from "../../context/ThemeContext";

const Header = ({ onOpenFilmModal }) => {
	const [isOpen, setIsOpen] = useState(false);
	const [cookies, , removeCookie] = useCookies(["user"]);
	const [isControlPanelMode, setIsControlPanelMode] = useState(false);
	const [showAllItems, setShowAllItems] = useState(true);
	const [activeDropdown, setActiveDropdown] = useState(null);
	const navigate = useNavigate();
	const timeoutRef = useRef(null);
	const headerRef = useRef(null);
	const location = useLocation();
	const { theme, toggleTheme } = useTheme();

	const user = JSON.parse(localStorage.getItem("user"))||cookies.user;
	console.log(user,"userAdmin")
	// Close dropdowns when clicking outside
	useEffect(() => {
		const handleClickOutside = (event) => {
			if (headerRef.current && !headerRef.current.contains(event.target)) {
				setActiveDropdown(null);
			}
		};

		document.addEventListener("mousedown", handleClickOutside);
		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, []);

	const handleLogout = () => {
		removeCookie("user", { path: "/" });
		removeCookie("token", { path: "/" });
		localStorage.removeItem("user");
		localStorage.removeItem("token");
		localStorage.removeItem("userId");
		navigate("/");
	};

	// eslint-disable-next-line no-unused-vars
	const handleControlPanelClick = () => {
		clearTimeout(timeoutRef.current);
		setIsControlPanelMode(true);
		setShowAllItems(false);

		if (!showAllItems) {
			setShowAllItems(true);
			timeoutRef.current = setTimeout(() => {
				setShowAllItems(false);
			}, 3000);
		}
	};

	const handleOtherNavClick = () => {
		clearTimeout(timeoutRef.current);
		setIsControlPanelMode(false);
		setShowAllItems(true);

		timeoutRef.current = setTimeout(() => {
			if (isControlPanelMode) {
				setShowAllItems(false);
			}
		}, 3000);
	};

	const toggleDropdown = (menuName) => {
		setActiveDropdown(activeDropdown === menuName ? null : menuName);
	};

	const shouldShowItem = (item) => {
		if (!isControlPanelMode) return true;
		if (showAllItems) return true;
		return item === "control-panel" || item === "logout";
	};

	// Clean up timeout on unmount
	useEffect(() => {
		return () => {
			if (timeoutRef.current) {
				clearTimeout(timeoutRef.current);
			}
		};
	}, []);

	const navItems = getNavItems(user, shouldShowItem);


	useEffect(() => {
		if (location.state?.scrollTo) {
			const id = location.state.scrollTo;

			setTimeout(() => {
				slowScrollTo(id, 600);
			}, 200);
		}
	}, [location.state]);

	const handleClick = (item) => {
		// Control Panel → always navigate
		if (item.label === "Control Panel"||item.label === "My Outlet") {
			navigate(item.path);
			return;
		}

		// If already on home → scroll
		if (location.pathname === "/") {
			slowScrollTo(item.path, 500);
		}
		// Otherwise → go home first, then scroll
		else {
			navigate("/", {
				state: { scrollTo: item.path },
			});
		}
	};

	const slowScrollTo = (targetId, duration = 1200) => {
		const target = document.getElementById(targetId);
		if (!target) return;

		const targetPosition =
			target.getBoundingClientRect().top + window.pageYOffset;
		const startPosition = window.pageYOffset;
		const distance = targetPosition - startPosition - 130;
		let startTime = null;

		const easeInOut = (t) =>
			t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;

		const animation = (currentTime) => {
			if (startTime === null) startTime = currentTime;
			const timeElapsed = currentTime - startTime;
			const progress = Math.min(timeElapsed / duration, 1);

			window.scrollTo(0, startPosition + distance * easeInOut(progress));

			if (timeElapsed < duration) {
				requestAnimationFrame(animation);
			}
		};

		requestAnimationFrame(animation);
	};

	return (
		<header className={`header ${isOpen ? "menuopen" : ""}`} ref={headerRef}>
			<div
				className="d-flex justify-content-between w-100 "
				onClick={handleOtherNavClick}>
				<Link
					to="/"
					className="logo d-flex gap-2 align-items-center"
					style={{ textDecoration: "none" }}>
					<img className="logo-image d-flex" src={logo} alt="Logo" />
					<p style={{ color: "#ff9d0b" }}>
						XEYEX<span style={{ color: "#7e16be" }}>MEDIA</span>
					</p>
				</Link>
				<div className=" d-none d-lg-flex align-items-center justify-content-center gap-5">
					<div className="">
						<a href="tel:8608257794" style={{ textDecoration: "none" }}>
							<div className="footer-p-details d-flex gap-3">
								<div className="footer-r-icon">
									<IoCall className="f-icons" />
								</div>
								<p>8608257794</p>
							</div>
						</a>
					</div>
					<div className="d-flex align-items-center gap-3">
						{onOpenFilmModal && (
							<button
								className="watch-film-trigger-btn me-2"
								onClick={onOpenFilmModal}
								title="Watch Short Film"
							>
								<FaFilm className="me-1" /> Watch Short Film
							</button>
						)}
						<div>
							<Link to="/contact">
								<button className="connect border-0 p-2">
									Let's Connect <FaArrowRight className="ms-2" />
								</button>
							</Link>
						</div>
					</div>
				</div>
				<MobileHeader
				isOpen={isOpen}
				setIsOpen={setIsOpen}
				navItems={navItems}
				user={user}
				onLogout={handleLogout}
				onNavigate={handleClick}
				onOpenFilmModal={onOpenFilmModal}
			/>
			</div>
			<div>
				<nav className="d-none d-lg-block">
					<ul className="nav-links">
						{navItems.map((item) => {
							if (item.show === false || !shouldShowItem(item.id)) return null;

							return (
								<li
									className="nav-item"
									key={item.id}
									onMouseEnter={
										item.dropdown ? () => toggleDropdown(item.id) : undefined
									}
									onMouseLeave={
										item.dropdown ? () => setActiveDropdown(null) : undefined
									}>
									<span
										className="headeroption"
										onClick={() => handleClick(item)}
										style={{ cursor: "pointer" }}>
										{item.label}
									</span>

									{item.dropdown && (
										<ul
											className={`dropdown ${
												activeDropdown === item.id ? "active" : ""
											}`}>
											{item.items.map((subItem) => (
												<li key={subItem.path}>
													<NavLink
														to={subItem.path}
														className={({ isActive }) =>
															isActive ? "selectsub" : ""
														}
														onClick={() => setActiveDropdown(null)}>
														{subItem.label}
													</NavLink>
												</li>
											))}
										</ul>
									)}
								</li>
							);
						})}

						<li className="nav-item">
						{user ? (
							<button onClick={handleLogout} className="logout-btn border-0">
								Logout
							</button>
						) : shouldShowItem("login") ? (
							<NavLink
								to="/login"
								className={({ isActive }) =>
									isActive ? "headerActive headeroption" : "headeroption"
								}>
								Login/Register
							</NavLink>
						) : null}
					</li>
					{/* ── Theme Toggle ── */}
					<li className="nav-item">
						<button
							className="theme-toggle-btn"
							onClick={toggleTheme}
							title={theme === "dark" ? "Switch to Light Mode" : "Switch to Dark Mode"}
							aria-label="Toggle theme">
							{theme === "dark" ? "☀️" : "🌙"}
						</button>
					</li>
					</ul>
				</nav>
			</div>
			
		</header>
	);
};

export default Header;
